// components
import maInputText from '@/components/input/modules/text'
import maPaginator from '@/components/paginator'
import maEmpty from '@/components/empty'
import maInputSelect from '@/components/input/modules/select'

// vuex
import { mapState, mapMutations } from 'vuex'

// api
import {
  apiGetSinisters,
  apiGetSinisterStatuses
} from '@/services/API/sinister'

// types
import {
  USER_MODULE_NAME,
  USER_UPDATE_SINISTERS,
  WARRANTY_MODULE_NAME,
  WARRANTY_CLEAR_MODULE,
  UPDATE_LOADER,
  WARRANTY_UPDATE_LAST_PIECE_SELECTED
} from '@/store/types'

/**
 * @module
 * @name search
 * @description Module designed to look for sinisters
 */
export default {
  name: 'search',
  /**
   * @property {String} sinisterId Siniter id filter.
   * @property {String} complementary Complementary Ref filter.
   * @property {Number} currentPage Current list page.
   * @property {Number} totalPages Number of pages.
   * @property {Array} filteredSinisters Array of sinisters.
   * @property {Boolean} disableSearchButton Enables search button if any
   *  corresponding input have change.
   */
  data: function() {
    return {
      sinisterId: null,
      complementaryRef: null,
      sinisterStatus: [],
      sinisterStatusValue: null,
      currentPage: 1,
      totalPages: 0,
      filteredSinisters: null,
      disableSearchButton: true,
      declarantMap: {
        'proprietaire': 'Propriétaire',
        'locataire': 'Locataire',
        'proprietarie_non_ocupant': 'Propriétaire Non Occupant'
      }
    }
  },
  components: {
    maInputText,
    maPaginator,
    maInputSelect,
    maEmpty
  },

  /**
   * @property {Boolean} sinisterExists Checks for sinister Id and his length.
   * @property {Boolean} hasSinisters Checks if there are filteredSinisters.
   * @property {Boolean} disableButton Disable button if sinisterId doesn't exist.
   */
  computed: {
    sinisterExists: function() {
      return this.sinisterId && this.sinisterId.length > 0
    },
    hasSinisters: function() {
      return this.filteredSinisters && this.filteredSinisters.length > 0
    },
    disableButton: function() {
      return !(
        (this.sinisterId && this.sinisterId.length > 0) ||
        this.sinisterStatusValue
      )
    }
  },
  methods: {
    ...mapState({
      lastPieceSelected: state => state.warranty.lastPieceSelected
    }),
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearModule: WARRANTY_CLEAR_MODULE
    }),
    ...mapMutations(USER_MODULE_NAME, {
      mutUserUpdateSinisters: USER_UPDATE_SINISTERS
    }),
    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),
    ...mapMutations(WARRANTY_MODULE_NAME, {
      updateLastPieceSelected: WARRANTY_UPDATE_LAST_PIECE_SELECTED
    }),

    /**
     * @function
     * @name handleSearch
     * @description Send sinisterId, complementaryRef and currentPage to get
     *  an array of objects.
     */
    handleSearch: function() {
      this.updateLoader(true)
      apiGetSinisters(
        this.sinisterId,
        this.complementaryRef,
        this.sinisterStatusValue,
        this.currentPage
      )
        .then(filteredSinisters => {
          this.filteredSinisters = filteredSinisters.results.map(r => ({
            ...r,
            declarant: this.declarantMap[r.declarant] || r.declarant
          }))
          this.totalPages = filteredSinisters.total_pages || 0
          this.mutUserUpdateSinisters(this.filteredSinisters || [])
        })
        .finally(() => {
          this.updateLoader(false)
        })
    },

    /**
     * @function
     * @name handleSearchButton
     * @description Search and set current page to first.
     */
    handleSearchButton: function() {
      this.currentPage = 1
      this.handleSearch()
    },

    /**
     * @function
     * @name handlePageUpdate
     * @param {Number} page Target page number.
     * @description Set current page to target and search with that page.
     */
    handlePageUpdate: function(page) {
      this.currentPage = page
      this.handleSearch()
    },

    /**
     * @function
     * @name handlePageSet
     * @param {Number} page Target page number.
     * @description Set currentPage with page target.
     */
    handlePageSet: function(page) {
      this.currentPage = page
    },

    /**
     * @function
     * @name handleEditClick
     * @description On click edit, redirects to warranty page info sinister_id.
     */
    handleEditClick: function(sinisterId, complementaryRef) {
      const editSinister = { name: 'editSearchBtn' }
      this.updateLastPieceSelected(editSinister)

      this.$router.push({
        name: 'warranty',
        params: { sinisterId, complementaryRef }
      })
    },

    /**
     * @function
     * @name setSinisterStatuses
     * @description retrieve and set sinister statuses into select component
     */
    setSinisterStatuses: function() {
      const that = this
      apiGetSinisterStatuses().then(statuses => {
        if (statuses && statuses.length > 0) {
          that.sinisterStatus = statuses
        }
      })
    }
  },

  /**
   * @function
   * @name mounted
   * @description On mounted, handle search for initial values.
   */
  mounted: function() {
    this.handleSearch()
  },

  beforeMount: function() {
    this.setSinisterStatuses()
    this.mutWarrantyClearModule()
  }
}
